import React from 'react';

const LeftColumn = () => {
    const tourDates = [
        { date: '12/11/08', location: 'We\'re Live!' },
        { date: '12/14/08', location: 'Starting out' }
    ];

    return (
        <div style={{ width: '30%'}}>
            <h2>Blog</h2>
            {/* <h3>JOHN BELTRAN TOUR DATES</h3> */}
            {/* <p><a href="#">(Click here to view all shows)</a></p> */}
            <ul style={{ listStyleType: 'none', padding: '0' }}>
                {tourDates.map((tour, index) => (
                    <li key={index}>
                        <strong>{tour.date}</strong> - {tour.location}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LeftColumn;